import { Component } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-number-input',
    standalone: false,
    templateUrl: './number-input.component.html',
    styleUrl: './number-input.component.scss',
})
export class NumberInputComponent extends InputComponent {}
